// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bFYH","top":"styles_top__2THQI","left":"styles_left__1WVdm","description":"styles_description__1W1Oi"};